/* eslint-disable import/no-named-as-default-member */
/* eslint-disable react/jsx-props-no-spreading */
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { Sidebar } from 'semantic-ui-react';
import loadable from '@loadable/component';
import React, { Suspense } from 'react';

import CircularLoader from '../../r/components/shared/loader/circular';
import MetaData from '../../r/components/shared/metadata';
import AuthProvider from './auth/components/provider';
import Footer from './shared/layout/footer';
import Navbar from './shared/layout/navbar';
import { getRoutePath } from '../utils';

const loadableOptions = { fallback: <CircularLoader isPageLoader /> };

const LazyFeatures = loadable(() => import('./features/components'), loadableOptions);
const LazyReport = loadable(() => import('./report/components'), loadableOptions);
const LazyAuth = loadable(() => import('./auth/components'), loadableOptions);
const LazyNotFound = loadable(() => import('../../r/components/not-found'));

const App = () => {
  return (
    <Router basename="/e">
      <Sidebar.Pushable style={{ transform: 'unset' }}>
        <Sidebar.Pusher dimmed={false} style={{ overflow: 'unset' }}>
          <Navbar />

          <AuthProvider>
            <MetaData>
              <Suspense fallback={loadableOptions.fallback}>
                <Switch>
                  {/* Route index to features page for the moment until the main homepage is re-written in React. */}
                  <Route exact path="/" render={(props) => <LazyFeatures {...props} />} />

                  <Route exact path={getRoutePath('Features')} render={(props) => <LazyFeatures {...props} />} />
                  <Route exact path={getRoutePath('Report')} render={(props) => <LazyReport {...props} />} />
                  <Route path="/auth" render={(props) => <LazyAuth {...props} />} />

                  {/* NotFound component must be last entry */}
                  <Route path="*" render={(props) => <LazyNotFound {...props} />} />
                </Switch>
              </Suspense>
            </MetaData>
          </AuthProvider>

          <Footer />
        </Sidebar.Pusher>
      </Sidebar.Pushable>
    </Router>
  );
};

export default App;
